module.exports = __webpack_public_path__ + "images/category_lp/watch/omega_samples/cv_3_sp_fdc4ed22915a575c6c53ad9fa7e09b21.jpg";